module.exports = __webpack_public_path__ + "img/scoping-wizard.cfe56616.png";